import api from './axios';

export const getParcels = (params) => api.get('/parcels/', { params });
export const getParcel = (id) => api.get(`/parcels/${id}/`);
export const createParcel = (data) => api.post('/parcels/', data);
export const updateParcel = (id, data) => api.patch(`/parcels/${id}/`, data);
export const deleteParcel = (id) => api.delete(`/parcels/${id}/`);
